import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "targets-list-main" }
const _hoisted_2 = { class: "targets-list-list" }
const _hoisted_3 = {
  key: 0,
  class: "text-label"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h3", null, _toDisplayString(_ctx.t('fleet.clusterTargets.rules.matching.title', { n: $options.clustersRenderList.length })), 1),
    _cache[2] || (_cache[2] = _createTextVNode()),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.clustersRenderList, (cluster, i) => {
        return (_openBlock(), _createElementBlock("span", {
          key: i,
          class: "row mt-5"
        }, [
          _createVNode(_component_router_link, {
            to: cluster.detailLocation,
            target: "_blank",
            class: "link-main"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(cluster.name) + " ", 1),
              _cache[0] || (_cache[0] = _createElementVNode("i", { class: "link-icon icon icon-external-link" }, null, -1))
            ]),
            _: 2,
            __: [0]
          }, 1032, ["to"])
        ]))
      }), 128)),
      _cache[1] || (_cache[1] = _createTextVNode()),
      (!$options.clustersRenderList.length)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString($props.emptyLabel || _ctx.t('fleet.clusterTargets.rules.matching.empty')), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}